import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './ProtectedRoute.css';

/**
 * Protected Route Component
 * Protege rutas que requieren autenticación con diseño premium
 * 
 * MODO DESARROLLO: Bypass activado para trabajar sin autenticación
 */
const ProtectedRoute = ({ children, requiredRoles }) => {
    const { isAuthenticated, checkingAuth, hasRole } = useAuth();

    // Loading screen premium (Solo durante la verificación inicial)
    if (checkingAuth) {
        return (
            <div className="protected-loading">
                <div className="loading-content">
                    <div className="loading-spinner-container">
                        <div className="loading-spinner"></div>
                        <div className="loading-pulse"></div>
                    </div>
                    <h3 className="loading-text">Verificando sesión</h3>
                    <p className="loading-subtext">Un momento por favor...</p>
                </div>
            </div>
        );
    }

    // Si no está autenticado, redirigir a login
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Si se requieren roles específicos, verificar
    if (requiredRoles && requiredRoles.length > 0) {
        const hasRequiredRole = hasRole(requiredRoles);

        if (!hasRequiredRole) {
            return (
                <div className="protected-denied">
                    <div className="denied-content">
                        <div className="denied-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                        </div>
                        <h2>Acceso Denegado</h2>
                        <p>No tienes permisos para acceder a esta página.</p>
                        <p className="denied-subtext">
                            Contacta al administrador si crees que esto es un error.
                        </p>
                        <button
                            className="back-button"
                            onClick={() => window.history.back()}
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Volver atrás
                        </button>
                    </div>
                </div>
            );
        }
    }

    // Usuario autenticado y con permisos
    return children;
};

export default ProtectedRoute;
